package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card


import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.getEndOfDay
import org.hs_soft.runmynesto.domain.util.getEndOfWeek
import org.hs_soft.runmynesto.domain.util.getStartOfDay
import org.hs_soft.runmynesto.domain.util.getStartOfWeek
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class PeriodDaysEnum(
    val from: String,
    val to: String
) {
    TODAY(
        from = getStartOfDay(0),
        to = getEndOfDay(0)
    ),
    YESTERDAY(
        from = getStartOfDay(-1),
        to = getEndOfDay(-1)
    ),
    THIS_WEEK(
        from = getStartOfWeek(0),
        to = getEndOfWeek(0)
    ),
    PREVIOUS_WEEK(
        from = getStartOfWeek(-1),
        to = getEndOfWeek(-1)
    );

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            TODAY -> strings.today
            YESTERDAY -> strings.yesterday
            THIS_WEEK -> strings.thisWeek
            PREVIOUS_WEEK -> strings.previousWeek
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                TODAY -> strings.today
                YESTERDAY -> strings.yesterday
                THIS_WEEK -> strings.thisWeek
                PREVIOUS_WEEK -> strings.previousWeek
            }
        }
}